import { Fragment, useState } from 'react';
import Scrollbars from 'react-custom-scrollbars';
import type {
  SeatData,
  SeatMemberData,
} from '@modules/header/ShareConfigModal/types';
import TextLink from '@components/TextLink';
import { DeptItem, MemberItem, RootItem } from './SeatItems';

export function SeatsOptions() {
  const [list, setList] = useState<
    {
      id: number;
      name: string;
      departments: SeatData['departments'];
      members: SeatMemberData[];
    }[]
  >([]);

  function renderHeader() {
    if (list.length === 0) {
      return '组织架构';
    }
    return (
      <>
        <TextLink
          className="shrink-0"
          onClick={() => {
            setList([]);
          }}
        >
          组织架构
        </TextLink>
        {list.map((x, i) => (
          <Fragment key={x.id}>
            <div className="mx-5">{'>'}</div>
            {i === list.length - 1 ? (
              <div className="max-w-[170px] truncate" title={x.name}>
                {x.name}
              </div>
            ) : (
              <TextLink
                className="max-w-[170px] truncate"
                title={x.name}
                onClick={() => {
                  setList(list.slice(0, i + 1));
                }}
              >
                {x.name}
              </TextLink>
            )}
          </Fragment>
        ))}
      </>
    );
  }

  const renderRoot = () => {
    return (
      <RootItem
        onNextClick={(payload) => {
          setList([
            {
              id: payload.id,
              name: payload.name,
              departments: payload.depts,
              members: payload.members,
            },
          ]);
        }}
      />
    );
  };

  const renderList = () => {
    const lastItem = list[list.length - 1];
    return (
      <Scrollbars>
        {lastItem.departments.map((x) => (
          <DeptItem
            key={x.id}
            data={x}
            onNextClick={(payload) => {
              setList((prev) => {
                return [
                  ...prev,
                  {
                    id: payload.id,
                    name: payload.name,
                    departments: payload.depts,
                    members: payload.members,
                  },
                ];
              });
            }}
          />
        ))}
        {lastItem.members.map((x) => (
          <MemberItem key={x.memberId} data={x} />
        ))}
      </Scrollbars>
    );
  };

  return (
    <div className="flex min-w-0 flex-1 flex-col pr-20">
      <div className="mb-10 flex min-w-0 items-center">{renderHeader()}</div>
      <div className="flex-1">{list.length ? renderList() : renderRoot()}</div>
    </div>
  );
}

export default SeatsOptions;
